<template>
  <div>
    <user-table ref="table" :url="indexUrl">
      <template v-slot:buttons>
        <button class="btn btn-purple" v-if="canCreate" @click="addUser">
          <i class="far fa-file"></i>
        </button>
      </template>
    </user-table>
    <assign-group-dialog></assign-group-dialog>
  </div>
</template>

<script>
import eventBus from '../../event-bus';
import UserTable from '../../components/user/table';
import AssignGroupDialog from '../../components/shared/security-group/user-binding/dialog';

export default {
  components: {
    UserTable,
    AssignGroupDialog,
  },

  props: {
    indexUrl: null,
    createUrl: null,
    canCreate: {
      type: Boolean,
      default: false
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.table.refresh();
    },

    /**
     * @return {undefined}
     */
    addUser() {
      window.location = this.createUrl;
    },
  },

  created() {
    eventBus.$on('refresh-users-table', this.refresh);
  },

  beforeDestroy() {
    eventBus.$off('refresh-users-table', this.refresh);
  },
}
</script>
